import React from 'react';
import { RadioChangeEvent } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '@app/types/app';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { setTheme } from '@app/store/slices/themeSlice';
import { themeObject } from '@app/styles/themes/themeVariables';
import * as S from './ThemePicker.styles';

const themeOptions: { value: ThemeType; labelKey: string }[] = [
  { value: 'light', labelKey: 'header.themeNames.light' },
  { value: 'dark', labelKey: 'header.themeNames.dark' },
  { value: 'cnh', labelKey: 'header.themeNames.cnh' },
];

export const ThemePicker: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.theme.theme);

  const handleThemeChange = (event: RadioChangeEvent) => {
    dispatch(setTheme(event.target.value as ThemeType));
  };

  return (
    <S.ThemeOptions
      value={theme}
      onChange={handleThemeChange}
      aria-label={t('header.changeTheme')}
    >
      {themeOptions.map((option) => {
        const previewTheme = themeObject[option.value];

        return (
          <S.ThemeOption key={option.value} value={option.value}>
            <S.SelectedBadge aria-hidden="true">
              <CheckOutlined />
            </S.SelectedBadge>
            <S.ThemePreview $theme={previewTheme} aria-hidden="true">
              <S.PreviewHeader />
              <S.PreviewLayout>
                <S.PreviewSidebar />
                <S.PreviewContent>
                  <S.PreviewTableHeader />
                  <S.PreviewLine />
                  <S.PreviewLine $short />
                  <S.PreviewButton />
                </S.PreviewContent>
              </S.PreviewLayout>
            </S.ThemePreview>
            <S.ThemeLabel>{t(option.labelKey)}</S.ThemeLabel>
          </S.ThemeOption>
        );
      })}
    </S.ThemeOptions>
  );
};
